jQuery(function ($) {
	var rssurl = "https://naery.fi/wp-content/media-rss.xml";
	// $("#pressfeed").rss( rssurl, {
	// 	ssl:true
	// } );

	//feed to parse
	var feed = rssurl;

	$.ajax(feed, {
		accepts: {
			xml: "application/rss+xml",
		},
		dataType: "xml",
		success: function (data) {
			//Credit: http://stackoverflow.com/questions/10943544/how-to-parse-an-rss-feed-using-javascript
			$current = 0;
			$max = 10;
			$(data)
				.find("item:lt(7)")
				.each(function () {
					// or "item" or whatever suits your feed
					var el = $(this);

					var title = el.find("title").text();
					var link = el.find("link").text();

					$("#pressfeed").append(
						'<p><a href="' +
							link +
							'" target="_blank">' +
							title +
							"</a></p>"
					);
				});
			$(data)
				.find("item:lt(10)")
				.each(function () {
					// or "item" or whatever suits your feed
					var el = $(this);

					var title = el.find("title").text();
					var link = el.find("link").text();

					$("#largepressfeed").append(
						'<p><a href="' +
							link +
							'" target="_blank">' +
							title +
							"</a></p>"
					);
				});
		},
	});
});
